import Section from "components/common/Section";
import StaticPageHeader from "components/common/StaticPageHeader";
import usePageMeta from "hooks/usePageMeta";

const Terms = () => {
  usePageMeta(
    "Terms of Service | Transform the world through revealed knowledge",
    "Review the Ubay.pk terms of service. Simple, clear expectations for using our free non-profit Islamic quiz platform in Pakistan.",
    "/terms"
  );

  return (
    <div className="min-h-screen relative">
      {/* Background */}
      <img src="/assets/imgs/bg.jpg" alt="" className="fixed inset-0 h-full w-full object-cover -z-10" />

      <StaticPageHeader currentPage="Terms of Service" />
      <Section asMain>
        <div className="py-8 sm:py-12">
          <div className="max-w-4xl mx-auto space-y-6">

            {/* Hero */}
            <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-6 sm:p-8 shadow-xl">
              <p className="text-sm font-semibold text-emerald-600 mb-2">Simple, clear expectations</p>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-3">Terms of Service</h1>
              <p className="text-slate-700 text-base sm:text-lg leading-relaxed">
                By using Ubay.pk you agree to these terms. We keep them concise to respect your time.
              </p>
            </div>

            {/* Sections */}
            <div className="space-y-4">
              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Service scope</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  <li>Daily Islamic question; answer revealed next day.</li>
                  <li>Participation is educational and non-commercial.</li>
                  <li>Currently operating in Pakistan.</li>
                </ul>
              </div>

              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Eligibility & conduct</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  {/* <li>You affirm you are 13+; for legal agreements you should be 18+ or have guardian consent.</li> */}
                  <li>No abusive, harmful, or inappropriate content. Zero tolerance for harassment.</li>
                  <li>Do not misuse the platform (no scraping, spamming, or attempts to disrupt service).</li>
                </ul>
              </div>

              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Content & intellectual property</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  <li>Ubay.pk content is for personal, non-commercial use.</li>
                  <li>You may share links; can copy or redistribute content without permission.</li>
                  <li>User submissions must respect others' rights and applicable law.</li>
                </ul>
              </div>

              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Disclaimers</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  {/* <li>Service is provided "as is"; availability and accuracy are not guaranteed.</li> */}
                  {/* <li>We are not liable for indirect or consequential losses; total liability is limited to USD 50.</li> */}
                  <li>You are responsible for your account security and activity.</li>
                </ul>
              </div>

              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Account & termination</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  <li>You can request to delete your account at any time; we will remove personal data within a reasonable timeframe.</li>
                  <li>We may suspend or terminate access for misuse or legal reasons.</li>
                </ul>
              </div>

              <div className="bg-emerald-50/90 backdrop-blur-xl border border-emerald-200/60 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Contact</h2>
                <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                  Questions about these terms? Contact <span className="font-semibold">Ubay</span> at
                  <a className="ml-1 underline text-emerald-700 decoration-emerald-200 hover:decoration-emerald-500" href="mailto:ubayplatform@gmail.com">ubayplatform@gmail.com</a>.
                </p>
              </div>
            </div>

          </div>
        </div>
      </Section>
    </div>
  );
};

export default Terms;
